import i18n from "i18next";
import { ReactNode, useEffect, useState } from "react";
import { I18nextProvider, initReactI18next } from "react-i18next";

import ar from "@/locales/ar.json";
import de from "@/locales/de.json";
import en from "@/locales/en.json";
import es from "@/locales/es.json";
import tr from "@/locales/tr.json";

i18n.use(initReactI18next).init({
    lng: localStorage.getItem("lang") || "tr",
    fallbackLng: "tr",

    resources: {
        es: { translation: es },
        en: { translation: en },
        de: { translation: de },
        tr: { translation: tr },
        ar: { translation: ar },
    },
});

const LanguageProvider = ({ children }: { children: ReactNode }) => {
    // DEVELOPMENT
    const [lang, setLang] = useState<string>(i18n.language);
    const [autoChanger, setAutoChanger] = useState<boolean>(false);
    useEffect(() => {
        if (!autoChanger) return;
        // Automatically change language each 1 second
        const interval = setInterval(() => {
            const langs = ["en", "es", "de", "tr", "ar"];
            const current = i18n.language;
            setLang(current);

            let index = langs.indexOf(current);
            if (index === -1 || index >= langs.length - 1) index = 0;

            i18n.changeLanguage(langs[index + 1]);
        }, 10);

        return () => clearInterval(interval);
    }, [autoChanger]);

    // const { auth, setAuth } = useAuth();

    const [devBoxPosition, setDevBoxPosition] = useState("left-0");
    const [devBoxOpen, setDevBoxOpen] = useState(false);

    return (
        <I18nextProvider i18n={i18n}>
            {devBoxOpen && (
                <div className={`fixed opacity-50 bg-red-500 p-2 bottom-0 ${devBoxPosition} text-[8px] z-50`}>
                    <div
                        className="cursor-pointer"
                        onClick={() => {
                            setDevBoxOpen(false);
                        }}
                    >
                        CLOSE (x)
                    </div>
                    <div
                        className="cursor-pointer"
                        onClick={() => {
                            setAutoChanger(!autoChanger);
                        }}
                    >
                        Lang = {lang}
                    </div>
                    {/* <div
                        className="cursor-pointer"
                        onClick={() => {
                            setAuth(auth ? null : { ok: true, accessToken: "123", refreshToken: "123" });
                        }}
                    >
                        Toggle auth
                    </div> */}
                    <div
                        className="cursor-pointer"
                        onClick={() => {
                            setDevBoxPosition(devBoxPosition === "left-0" ? "right-0" : "left-0");
                        }}
                    >
                        Toggle position
                    </div>
                </div>
            )}
            {children}
        </I18nextProvider>
    );
};

export default LanguageProvider;
